// import Swiper JS
import simpleParallax from 'simple-parallax-js';

var images = document.querySelectorAll('.parallax');
new simpleParallax(images);